import CircularProgress from '@mui/material/CircularProgress'
import { connectorApi } from 'api/connector/api.ts'
import unLinked from 'assets/image/auth-steps/unLinked.png'
import clsx from 'clsx'
import { AuthTemplate } from 'components/templates/authTemplate'
import { notifyError } from 'shared/errors/notificate.ts'
import { useAppSelector, useSwitcher } from 'shared/hooks/index'
import { typo } from 'shared/styles'
import { Button } from 'shared/ui/index.ts'

import { appSelectors } from '../../../../redux/reducers/app.ts'
import { ModalConfirmLinkedInProfile } from './modal.tsx'
import css from './NoLinkedinContainer.module.scss'

const cn = AuthTemplate.cn

export function NoLinkedin() {
	const modalSwitch = useSwitcher(false)

	const email = useAppSelector(
		state => appSelectors.appProfile(state)?.email ?? ''
	)

	const [getProfile, { data: profile, isLoading }] =
		connectorApi.useCaptureLinkedInMutation()

	const getLinkedProfile = () => {
		if (!isLoading) {
			getProfile().unwrap().then(modalSwitch.on).catch(notifyError)
		}
	}

	const [signOut, { isLoading: isSigningOut }] =
		connectorApi.useSignOutMutation()

	const logout = () => {
		if (!isSigningOut) {
			signOut().unwrap().catch(notifyError)
		}
	}

	return (
		<AuthTemplate active={3} className={css.root}>
			<span className={clsx(css.email, typo.mediumBody)}>{email}</span>

			<h1 className={clsx(cn.title, css.title)}>Link your LinkedIn account</h1>

			<img alt='unLinked' className={cn.image} src={unLinked} width={130} />
			<p className={clsx(cn.text, css.text)}>
				Please, make sure you are signed in to LinkedIn with right account.
				Check it before you continue!
			</p>

			<div className={css.actions}>
				<Button
					className={cn.action}
					onClick={logout}
					type='button'
					typography={typo.largeButton}
					variant='secondary'
				>
					{isSigningOut ? (
						<CircularProgress
							classes={{ colorPrimary: 'material-loader-accent' }}
							size={20}
						/>
					) : (
						'Log Out'
					)}
				</Button>

				<Button
					className={cn.action}
					onClick={getLinkedProfile}
					type='button'
					typography={typo.largeButton}
				>
					{isLoading ? (
						<CircularProgress
							classes={{ colorPrimary: 'material-loader-accent' }}
							size={20}
						/>
					) : (
						'Continue'
					)}
				</Button>
			</div>

			<ModalConfirmLinkedInProfile
				onClose={modalSwitch.off}
				open={modalSwitch.isOn}
				profile={profile!}
			/>
		</AuthTemplate>
	)
}
